// One instance per Discover menu: tmExploreButton() makes one; cExploreButton is the page's first, and init() gives every
// other .c-explore-button-container on the page its own (a dropdown per destination, Cool Hawaii's islands; COOL 717)
const tmExploreButton = function () {
    let cExploreButtonElement,
        cExploreContainer,
        cExploreButtonArrowElement,
        cExploreButtonDropdownElement,
        cExploreButtonSelectedTab,
        cExploreButtonSelectedLeft = null, // data-id of the left-menu item last hovered (null = the section's first)
        bound = false;

    // Read from the container on every call, never cached: tmExploreMenuLoader (below) can replace the panel's markup
    const sections = function () { return $(cExploreButtonElement).find(".c-explore-section"); };
    const tabs = function () { return $(cExploreButtonElement).find(".c-tabs"); };
    const menuRight = function () { return $(cExploreButtonElement).find(".c-explore-section-menu-right"); };
    const activeTabKey = function () {
        return $(cExploreButtonElement).find(".c-tabs-item-active[data-tab-item-key]").data("tab-item-key")
            || $(cExploreButtonElement).find(".c-tabs-item[data-tab-item-key]").first().data("tab-item-key");
    };

    const reset = function () {
        const cExploreButtonSection = sections(), cExploreButtonTabs = tabs();
        cExploreButtonSelectedLeft = null;
        cExploreButtonSection.hide(); // Hide all initially
        cExploreButtonTabs.find(".c-tabs-item").removeClass("c-tabs-item-active");
        cExploreButtonTabs.find(`.c-tabs-item[data-tab-item-key='${cExploreButtonSelectedTab}']`).addClass("c-tabs-item-active");

        let selectedSection = cExploreButtonSection.filter(`[data-tab-id='${cExploreButtonSelectedTab}']`);
        selectedSection.find(".c-explore-section-menu-right div[data-left-menu]").hide();
        selectedSection.find(".c-explore-section-menu-right div[data-left-menu]:eq(0)").show();
        selectedSection.find(".c-explore-section-menu-left li").removeClass("c-menu-left-item-active");
        selectedSection.find(".c-explore-section-menu-left li:eq(0)").addClass("c-menu-left-item-active");

        selectedSection.show(); // Show the selected one
    };

    const handleTabHover = function () {
        const cExploreButtonSection = sections();
        $(this).siblings().removeClass("c-tabs-item-active");
        $(this).addClass("c-tabs-item-active");

        cExploreButtonSelectedTab = $(this).data("tab-item-key");
        cExploreButtonSelectedLeft = null;

        cExploreButtonSection.hide(); // Hide all initially
        let selectedSection = cExploreButtonSection.filter(`[data-tab-id='${cExploreButtonSelectedTab}']`);
        selectedSection.show(); // Show the selected one

        selectedSection.find(".c-explore-section-menu-right div[data-left-menu]").hide();
        selectedSection.find(".c-explore-section-menu-right div[data-left-menu]:eq(0)").css("display", "flex");
        selectedSection.find(".c-explore-section-menu-left li").removeClass("c-menu-left-item-active");
        selectedSection.find(".c-explore-section-menu-left li:eq(0)").addClass("c-menu-left-item-active");
    };

    const handleLeftMenuHover = function () {
        const cExploreButtonMenuRight = menuRight();
        const currentHover = $(this).data("id");
        cExploreButtonSelectedLeft = currentHover;
        $(this).siblings().removeClass("c-menu-left-item-active");
        $(this).addClass("c-menu-left-item-active");

        cExploreButtonMenuRight.find("div[data-left-menu]").hide();
        cExploreButtonMenuRight.find(`div[data-left-menu='${currentHover}']`).show();
    };

    // Re-applies the current state to new panel markup (tmExploreMenuLoader swapped the compact panel for the full
    // one): keeps the selected tab when the new markup has it, and in an open panel the hovered left-menu item too
    const refresh = function () {
        if (!bound) return; // init has not run: it will read the markup itself
        if (!cExploreButtonSelectedTab || !tabs().find(`.c-tabs-item[data-tab-item-key='${cExploreButtonSelectedTab}']`).length) {
            cExploreButtonSelectedTab = activeTabKey();
        }
        const keepLeft = cExploreButtonDropdownElement.hasClass("show") ? cExploreButtonSelectedLeft : null;
        reset();
        if (keepLeft) {
            const leftItem = sections().filter(`[data-tab-id='${cExploreButtonSelectedTab}']`)
                .find(".c-explore-section-menu-left li").filter(`[data-id='${keepLeft}']`).first();
            if (leftItem.length) {
                handleLeftMenuHover.call(leftItem.get(0));
            }
        }
    };

    return {
        init: function (obj) {
            if (!obj) return;
            const roots = $(obj);
            if (!bound && roots.length > 1) {
                roots.slice(1).each(function () { tmExploreButton().init(this); });
                obj = roots.get(0);
            }
            if (bound) { // a second call never binds again (document handlers would stack), it only re-reads the markup
                refresh();
                return;
            }
            bound = true;

            cExploreButtonElement = obj;
            cExploreButtonArrowElement = $(cExploreButtonElement).find(".c-explore-button > i"); // the button's chevron, not the panel's icons (a View all arrow, COOL 711) nor a destination's icon (COOL 717)
            cExploreContainer = $(cExploreButtonElement).find("i");
            cExploreButtonDropdownElement = $(cExploreButtonElement).find(".c-explore-menu");
            cExploreButtonSelectedTab = activeTabKey();

            reset();

            $(cExploreButtonElement).on('click', function (e) {
                e.stopPropagation();
                // another destination's menu closes as this one opens (they share the place under the header)
                $(".c-explore-button-container.menu-opened").not(cExploreButtonElement).each(function () {
                    $(this).removeClass("menu-opened").find(".c-explore-menu").removeClass("show");
                    $(this).find(".c-explore-button > i").removeClass("fa-chevron-up").addClass("fa-chevron-down");
                });
                cExploreButtonArrowElement.toggleClass("fa-chevron-down fa-chevron-up");
                reset();
                cExploreButtonDropdownElement.toggleClass('show');
                $(cExploreButtonElement).toggleClass("menu-opened");

                if ( cExploreButtonDropdownElement.hasClass("show") ){
                    // a sub-site's menu (data-explore-lock-height): on the first opening, as tall as its tallest tab, then
                    // fixed there whichever tab shows, as cooldestinations' set height is (Peter, COOL 711). Each tab is
                    // shown once, with its first group, to measure it, before the selected one comes back
                    const menu = cExploreButtonDropdownElement.get(0);
                    if ( menu.hasAttribute("data-explore-lock-height") && !menu.dataset.exploreLockedHeight ){
                        let tallest = menu.offsetHeight;
                        sections().each(function () {
                            sections().hide();
                            $(this).find(".c-explore-section-menu-right div[data-left-menu]").hide().first().show();
                            $(this).show();
                            tallest = Math.max(tallest, menu.offsetHeight);
                        });
                        reset();
                        menu.dataset.exploreLockedHeight = tallest;
                        menu.style.minHeight = tallest + "px";
                    }
                    if ( typeof window.avatarMenu === 'object' ){
                        window.avatarMenu.hide();
                    }
                    if ( typeof window.languageDropdownMenu === 'object' ){
                        window.languageDropdownMenu.hide();
                    }
                    if ( typeof window.searchBoxDesktop === 'object' ){
                        window.searchBoxDesktop.hide();
                    }
                }
            });

            // Close dropdown when clicking outside
            $(document).on("click", function () {
                cExploreButtonDropdownElement.removeClass("show");
                $(cExploreButtonElement).removeClass("menu-opened");
                cExploreButtonArrowElement.removeClass("fa-chevron-up");
                cExploreButtonArrowElement.addClass("fa-chevron-down");
            });

            // Delegated from .c-explore-menu, which stays in place when tmExploreMenuLoader replaces .c-explore-menu-inner
            cExploreButtonDropdownElement.on("mouseenter", ".c-tabs-item[data-tab-item-key]", handleTabHover);
            // bound once here, not in handleTabHover: the left menu must work before any tab is hovered
            cExploreButtonDropdownElement.on("mouseenter", ".c-explore-section-menu-left li", handleLeftMenuHover);

            // Prevent closing when clicking inside dropdown
            cExploreButtonDropdownElement.on("click", function (e) {
                e.stopPropagation();
            });
        },
        refresh: refresh
    };
};
const cExploreButton = tmExploreButton();

/* Discover menu on demand (cooldestinations). A root carrying data-explore-menu-url ships the desktop panel in compact
   form and the phone nav empty; the full markup is fetched on the first hover, focus, touch or click of the menu's
   button and swapped in. Roots without the attribute (every other site, or the rollback switch) carry the full menus
   inline and nothing here binds, but for the weather of a single-destination site's phone and Discover menus (data-explore-weather-url).
   Opening never waits: the menu opens on what is there and the full markup replaces it when it arrives. On a destination menu the fragments carry an empty [data-explore-weather] slot; the weather pill is its
   own part (&part=weather, cached 15 minutes, not 4 h), requested once per page IN PARALLEL with the first menu fragment,
   and put in the slots, or the slots removed when there is none. Called from main.js after cExploreButton.init and new MobileLeftMenu. */
window.tmExploreMenuLoader = function () {
    const MAX_ATTEMPTS = 2; // per part: a failure leaves what is shown, the next trigger may try once more
    const PARTS = {
        desktop: {
            root: '.c-explore-button-container[data-explore-menu-url]',
            trigger: '.c-explore-button',
            target: '.c-explore-menu-inner',
            events: ['mouseenter', 'focus', 'touchstart', 'click']
        },
        mobile: {
            root: '.c-mobile-left-menu[data-explore-menu-url]',
            trigger: ':scope > .c-icon-button', // the bars button, not the panel header's back/close buttons
            target: '.c-mobile-left-menu-nav-container',
            events: ['touchstart', 'mouseenter', 'focus', 'click']
        }
    };
    const state = {}; // per part: { root, attempts, done, pending }
    let bound = false;
    const weathers = {}; // per endpoint: Promise of the weather pill's HTML ('' = none), shared by both parts (a menu per destination on Cool Hawaii, COOL 717)

    // The endpoint a root's parts hang off: the Discover menu's, or on a single-destination site's phone menu (its own
    // menu inline, its destination's name + weather above it) the weather's alone (data-explore-weather-url, COOL 276)
    const endpoint = function (root) {
        return root.dataset.exploreMenuUrl || root.dataset.exploreWeatherUrl || '';
    };

    // The attribute holds the English endpoint; a translated cooldestinations page asks under its own /xx/ prefix so the
    // translation proxy translates the fragment (the page's path segment, tmPathLanguageCode: a site translated in place
    // has no prefixed URLs, its fragment stays English — COOL 639). A language segment already in the attribute (a
    // proxy rewrite) is dropped first.
    // country: the visitor's, sent as &cc= for the countries listed in the root's data-explore-menu-countries
    // (TmMainMenuGenerator::fragmentCountries(): their own links lead their group, their own Top categories; a cached copy each),
    // on the general menu only: a destination menu has neither, so &cc= would only split its cache (COOL 579).
    const requestUrl = function (root, name, country) {
        const url = new URL(endpoint(root), window.location.origin);
        url.pathname = url.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/wp-admin\/)/i, '');
        const lang = typeof window.tmPathLanguageCode === 'function' ? window.tmPathLanguageCode() : 'en';
        if (lang && lang.toLowerCase() !== 'en') {
            url.pathname = '/' + lang + url.pathname;
        }
        url.searchParams.append('part', name);
        if (country && !url.searchParams.get('dest') && (root.dataset.exploreMenuCountries || '').split(',').indexOf(country) !== -1) {
            url.searchParams.append('cc', country);
        }
        return url.toString();
    };

    // The visitor's country (tmv-country: Cloudflare's, the same the checkout phone field starts on), looked up on a first
    // visit; '' when unknown or without tmVisitorStore. Never rejects.
    const visitorCountry = function () {
        try {
            return typeof tmVisitorStore === 'object' ? tmVisitorStore.resolveCountry().catch(function () { return ''; }) : Promise.resolve('');
        } catch (e) {
            return Promise.resolve('');
        }
    };

    // One weather request per destination, whichever part asks first. Resolves to the pill's markup, '' for none; never rejects.
    const loadWeather = function (root) {
        const key = endpoint(root);
        if (weathers[key]) return weathers[key];
        let weather;
        let url = '';
        try {
            if (typeof window.fetch === 'function' && typeof window.DOMParser === 'function'
                && new URL(endpoint(root), window.location.origin).searchParams.get('dest')) {
                url = requestUrl(root, 'weather');
            }
        } catch (e) {
            url = '';
        }
        if (!url) {
            weather = weathers[key] = Promise.resolve(''); // not a destination menu, or no fetch: no weather
            return weather;
        }
        // Default Accept, no custom headers: the response is cached (public, 15 min) on the URL alone; 204 = no weather
        weather = weathers[key] = window.fetch(url, { credentials: 'same-origin' })
            .then(function (response) {
                return response.status === 200 ? response.text() : '';
            })
            .then(function (text) {
                const node = text ? new DOMParser().parseFromString(text, 'text/html').querySelector('[data-explore-part="weather"]') : null;
                return node ? node.innerHTML.trim() : '';
            })
            .catch(function () { return ''; });
        return weather;
    };

    // Desktop: the pill is the last item of the tabs row, pushed to its right end. Where the tabs leave no room for it (a
    // long destination name on a narrow screen) its "• 8:24 PM" goes first (Peter, 2026-10-12), and the pill is hidden
    // only when the temperature alone still does not fit, rather than squeezed against the last tab. Checked whenever the panel's size changes,
    // which includes the panel opening (it has no size while closed).
    const fitWeather = function (slot, panel) {
        if (typeof window.ResizeObserver !== 'function') return;
        const check = function () {
            if (!slot.isConnected || !panel.offsetWidth) return;
            const tabs = panel.querySelectorAll('.c-tabs .c-tabs-item');
            const lastTab = tabs[tabs.length - 1];
            const time = slot.querySelectorAll('.simple-weather__day .c-dot-separator, .simple-weather__day [data-local-time]');
            const fits = function () {
                return !lastTab || slot.getBoundingClientRect().left >= lastTab.getBoundingClientRect().right + 8;
            };
            // measured shown, time included; no paint happens before the lines below
            slot.hidden = false;
            time.forEach(function (element) { element.hidden = false; });
            if (fits()) return;
            time.forEach(function (element) { element.hidden = true; });
            slot.hidden = !fits();
        };
        new window.ResizeObserver(check).observe(panel);
    };

    // The time at the place now, from the IANA zone the weather part carries: "8:24 PM (PDT)" (Peter, 2026-10-09). en-US
    // gives the 12-hour clock and the US zone names but only an offset elsewhere ("GMT+2"), so the zone's name comes from
    // the first English locale that has one (en-GB: BST, CEST, EEST; en-AU: AEDT), else the offset. short = the time
    // alone, "8:24 PM" (the pill, Peter 2026-10-09). '' when the browser cannot (an unknown zone, no formatToParts).
    const localTime = function (zone, short) {
        try {
            const date = new Date();
            const options = { timeZone: zone, hour: 'numeric', minute: '2-digit', timeZoneName: 'short' };
            const parts = function (locale) { return new Intl.DateTimeFormat(locale, options).formatToParts(date); };
            const zoneName = function (locale) {
                const part = parts(locale).filter(function (p) { return p.type === 'timeZoneName'; })[0];
                return part ? part.value : '';
            };
            const isOffset = function (value) { return /^(GMT|UTC)[+\-−]/.test(value); };
            const time = parts('en-US').filter(function (p) { return p.type !== 'timeZoneName'; })
                .map(function (p) { return p.value; }).join('').trim();
            if (short) return time;
            let name = zoneName('en-US');
            if (isOffset(name)) {
                name = ['en-GB', 'en-AU'].map(zoneName).filter(function (n) { return n && !isOffset(n); })[0] || name;
            }
            return time && name ? time + ' (' + name + ')' : time;
        } catch (e) {
            return '';
        }
    };

    // Writes the local time into the weather's [data-local-time] elements under root; where the browser cannot, the time
    // goes (with its dot on the pill, its line in the card).
    const showLocalTimes = function (root) {
        root.querySelectorAll('.c-explore-weather [data-local-time]').forEach(function (element) {
            const text = localTime(element.getAttribute('data-local-time'), element.hasAttribute('data-local-time-short'));
            if (text) {
                if (element.textContent !== text) element.textContent = text;
                return;
            }
            const dot = element.previousElementSibling;
            if (dot && dot.classList.contains('c-dot-separator')) dot.remove();
            const line = element.parentElement;
            (line && line.parentElement && line.parentElement.classList.contains('c-dropdown-menu-content') ? line : element).remove();
        });
    };

    // One timer per page, on the minute (every zone's offset is whole minutes), for both parts' pills and cards
    let clock = 0;
    const startClock = function () {
        if (clock) return;
        const tick = function () {
            showLocalTimes(document);
            clock = window.setTimeout(tick, 60050 - Date.now() % 60000);
        };
        clock = window.setTimeout(tick, 60050 - Date.now() % 60000);
    };

    // °F ⇄ °C on the pill and its card together (tmFlipTemperature, main.js; saves nothing: the switch saves through
    // tmTemperature, and tm_temperature_changed flips every pill, below). The card's switch shows the
    // label (rendered, so translated) of the other unit. instant = no fade (right after the pill is inserted).
    const flipUnit = function (wrapper, instant) {
        const temp = wrapper.querySelector('.simple-weather__temp');
        if (!temp || typeof window.tmFlipTemperature !== 'function') return;
        const toCelsius = temp.textContent.trim().endsWith('F');
        window.tmFlipTemperature(wrapper, instant);
        wrapper.querySelectorAll('[data-weather-unit] [data-unit-label]').forEach(function (label) {
            label.hidden = label.getAttribute('data-unit-label') !== (toCelsius ? 'F' : 'C');
        });
    };

    // The card (components/dropdown-menu, shown and hidden with its c-hidden class) under the pill: a click or tap on the
    // pill opens or closes it (Peter, 2026-10-09: "a click to open a menu dropdown style one"); a click or tap outside
    // it, or Escape, closes it. Clicks are caught on the way down (capture): the desktop dropdown stops them on the way
    // up (cExploreButton).
    const setCard = function (wrapper, open) {
        const card = wrapper.querySelector('.c-dropdown-menu');
        const pill = wrapper.querySelector('.simple-weather__day');
        if (card) card.classList.toggle('c-hidden', !open);
        if (pill) pill.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    const closeCards = function (except) {
        document.querySelectorAll('.c-explore-weather .c-dropdown-menu-wrapper').forEach(function (wrapper) {
            if (wrapper !== except) setCard(wrapper, false);
        });
    };
    const bindCards = function () {
        // the unit saved (the switch on any pill, the account's Temperature unit): every Discover menu pill shows it
        jQuery(document).on('tm_temperature_changed', function (e, data) {
            if (!data || !data.unit) return;
            document.querySelectorAll('.c-explore-weather .c-dropdown-menu-wrapper').forEach(function (wrapper) {
                const temp = wrapper.querySelector('.simple-weather__temp');
                if (temp && !temp.textContent.trim().endsWith(data.unit)) flipUnit(wrapper, false);
            });
        });
        document.addEventListener('click', function (event) {
            const target = event.target instanceof Element ? event.target : null;
            const wrapper = target ? target.closest('.c-explore-weather .c-dropdown-menu-wrapper') : null;
            if (!wrapper) {
                closeCards(null);
                return;
            }
            if (target.closest('[data-weather-unit]')) {
                const temp = wrapper.querySelector('.simple-weather__temp');
                if (window.tmTemperature && temp) {
                    // remembered (Peter, COOL 717): the visitor's pick, a signed-in visitor's account's too (tm-auth.js)
                    window.tmTemperature.setPreference(temp.textContent.trim().endsWith('F') ? 'C' : 'F');
                } else {
                    flipUnit(wrapper, false);
                }
            } else if (target.closest('.simple-weather__day')) {
                const card = wrapper.querySelector('.c-dropdown-menu');
                closeCards(wrapper);
                setCard(wrapper, !!card && card.classList.contains('c-hidden'));
            }
        }, true);
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') closeCards(null);
        });
    };

    // Puts the pill in the part's weather slot(s) once it is here, or removes the slot when there is no weather. The
    // temperatures are rendered in °F; the pill starts in the visitor's unit (tmTemperature, tm-temperature.js) when that
    // script is loaded, else in °C on a translated page. The switch in its card flips it.
    const fillWeather = function (name, root) {
        root = root || state[name].root;
        const target = root.querySelector(PARTS[name].target);
        const slots = target ? target.querySelectorAll('[data-explore-weather]') : [];
        if (!slots.length) return;
        loadWeather(root).then(function (html) {
            slots.forEach(function (slot) {
                if (!slot.isConnected) return; // the menu was replaced meanwhile
                if (!html) {
                    slot.remove();
                    return;
                }
                if (name === 'desktop') {
                    // the right end of the tabs row, in the row itself so it lines up with the tab labels
                    const row = target.querySelector('.c-tabs');
                    if (!row) {
                        slot.remove();
                        return;
                    }
                    row.appendChild(slot);
                }
                slot.innerHTML = html;
                showLocalTimes(slot);
                startClock();
                if (name === 'desktop') {
                    fitWeather(slot, target);
                }
                const flipToCelsius = function (unit) {
                    if (unit === 'C') {
                        slot.querySelectorAll('.c-dropdown-menu-wrapper').forEach(function (wrapper) {
                            flipUnit(wrapper, true);
                        });
                    }
                };
                if (window.tmTemperature) {
                    // a first visit has no tmv-country yet: resolveCountry looks it up (lower-case ISO2, or '')
                    tmVisitorStore.resolveCountry().then(function (country) {
                        flipToCelsius(window.tmTemperature.getEffectiveUnit(country));
                    });
                } else {
                    // the page's own language (its /xx/ prefix, cooldestinations), as before: an in-place pick on
                    // a brand site does not flip the unit (COOL 639)
                    const lang = typeof window.tmPathLanguageCode === 'function' ? window.tmPathLanguageCode() : 'en';
                    flipToCelsius(lang && lang.toLowerCase() !== 'en' ? 'C' : 'F');
                }
            });
        });
    };

    const apply = function (name, text) {
        const node = new DOMParser().parseFromString(text, 'text/html').querySelector(`[data-explore-part="${name}"]`);
        const target = state[name].root.querySelector(PARTS[name].target);
        if (!node || !node.firstElementChild || !target) {
            return false;
        }
        target.innerHTML = node.innerHTML;
        state[name].done = true;
        if (name === 'desktop') {
            cExploreButton.refresh();
        } else if (window.mobileLeftMenu && typeof window.mobileLeftMenu.refreshNav === 'function') {
            window.mobileLeftMenu.refreshNav();
        }
        if (typeof tmCurrency !== 'undefined' && tmCurrency.currencyUpdateEls) {
            tmCurrency.currencyUpdateEls(); // price links ("Under $50") arrive as USD tags, like tour prices
        }
        fillWeather(name);
        return true;
    };

    // Resolves true once the full markup is in, false on failure; never rejects. One request in flight per part.
    const load = function (name) {
        const part = state[name];
        if (!part) return Promise.resolve(false); // no root with the attribute: the full menu is inline
        if (part.done) return Promise.resolve(true);
        if (part.pending) return part.pending;
        if (part.attempts >= MAX_ATTEMPTS) return Promise.resolve(false);
        part.attempts++;

        if (typeof window.fetch !== 'function' || typeof window.DOMParser !== 'function') return Promise.resolve(false);
        loadWeather(part.root); // starts with the menu fragment, not after it; fillWeather() waits for it in apply()
        // Default Accept, no custom headers: the response is cached (public, 4 h) on the URL alone
        part.pending = visitorCountry()
            .then(function (country) {
                return window.fetch(requestUrl(part.root, name, country), { credentials: 'same-origin' });
            })
            .then(function (response) {
                return response.ok ? response.text().then(function (text) { return apply(name, text); }) : false;
            })
            .catch(function () { return false; })
            .then(function (ok) {
                part.pending = null;
                return ok;
            });
        return part.pending;
    };

    // A cooldestinations link in a sub-site's Discover or phone menu (its Nearby places) first shows the leaving-our-site
    // popup (components/leaving-site-modal.php), once per visit, as the route page's other ports do (shore-excursions/
    // script.php; Peter, COOL 711). "Understood, let's go!" takes the link's address and target; modifier clicks go through
    const bindLeavingSite = function () {
        const modal = document.getElementById('leaving-site-modal');
        const go = modal ? modal.querySelector('[data-leaving-site-go]') : null;
        if (!go || go.host === window.location.host) return;
        const storageKey = 'tmLeavingSiteSeen'; // shared with the route page's
        let seen = false; // this page's, when sessionStorage is unavailable
        document.addEventListener('click', function (e) {
            if (seen || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
            const link = e.target.closest('.c-explore-menu a[href], .c-mobile-left-menu a[href]');
            if (!link || link.host !== go.host) return;
            try { // read at click time: the route page's popup may have set it since
                if (window.sessionStorage.getItem(storageKey) === '1') return;
            } catch (err) {
            }
            e.preventDefault();
            e.stopPropagation(); // capture phase: before the menus' own handlers
            seen = true;
            try {
                window.sessionStorage.setItem(storageKey, '1');
            } catch (err) {
            }
            go.href = link.href;
            go.target = link.getAttribute('target') || '_self';
            modal.classList.add('modal-show');
            document.body.style.overflow = 'hidden';
        }, true);
        go.addEventListener('click', function () {
            modal.classList.remove('modal-show');
            document.body.style.overflow = 'auto';
        });
    };

    const init = function () {
        if (bound) return;
        bound = true;
        bindCards();
        bindLeavingSite();
        Object.keys(PARTS).forEach(function (name) {
            try { // an optional enhancement: never let it break the rest of main.js's ready handler
                const root = document.querySelector(PARTS[name].root);
                if (!root) return;
                state[name] = { root: root, attempts: 0, done: false, pending: null };
                const trigger = root.querySelector(PARTS[name].trigger);
                if (!trigger) return;
                const onTrigger = function () { load(name); };
                // Listen only (no preventDefault / stopPropagation): the menus' own click handlers still open them
                PARTS[name].events.forEach(function (type) {
                    trigger.addEventListener(type, onTrigger, type === 'touchstart' ? { passive: true } : false);
                });
            } catch (e) {
                // the menu keeps what the page shipped
            }
        });
        // A single-destination site's phone menu (COOL 276) and its own Discover menu (COOL 710): nothing to fetch but the
        // weather, on the first touch, hover, focus or click of the bars or Discover button, as the Discover menu's fragment;
        // each of the menus a destination each (Cool Hawaii's islands, COOL 717) its own destination's weather
        ['mobile', 'desktop'].forEach(function (name) {
            if (state[name]) return;
            document.querySelectorAll(PARTS[name].root.replace('data-explore-menu-url', 'data-explore-weather-url')).forEach(function (root) {
                try {
                    const trigger = root.querySelector(PARTS[name].trigger);
                    if (!trigger) return;
                    if (!state[name]) state[name] = { root: root, attempts: 0, done: true, pending: null }; // done: load(name) has no fragment to fetch
                    const onTrigger = function () {
                        PARTS[name].events.forEach(function (type) {
                            trigger.removeEventListener(type, onTrigger, type === 'touchstart' ? { passive: true } : false);
                        });
                        fillWeather(name, root);
                    };
                    PARTS[name].events.forEach(function (type) {
                        trigger.addEventListener(type, onTrigger, type === 'touchstart' ? { passive: true } : false);
                    });
                } catch (e) {
                    // the menu stays without the weather
                }
            });
        });
    };

    return { init: init, load: load };
}();
